import country from './country'
import province from './province'
import county from './county'
import city from './city'
import district from './district'
import trafficPlan from './traffic-plan'

export default {
  name: 'BaseInfoGeo',
  path: 'geo',
  meta: {
    label: 'geoLocations',
    auth: 'geo'
  },
  component: {
    name: 'Geo',
    render(c) {
      return c('router-view')
    }
  },
  children: [country, province, county, city, district, trafficPlan]
}
